import { EBuildingClassType } from '@/packages/api-models/common/json_query';

import { getTermsValue } from './helpers';
import { EBuildingClass, FOfferType, type NonEmptyArray, type TJsonQuery } from './types';
import { getOfferTypeFromJsonQuery } from './utils';
import { nonEmptyArrayOr } from './utils/nonEmptyArrayOr';

export function getBuildingClass(jsonQuery: TJsonQuery): NonEmptyArray<EBuildingClass> | null {
  const offerType = getOfferTypeFromJsonQuery(jsonQuery);
  const buildingClassTypes = getTermsValue('building_class_type')(jsonQuery);
  const warehouseBuildingClassTypes = getTermsValue('building_class_type__warehouse')(jsonQuery);
  const withWarehouse = (offerType & FOfferType.Warehouse) !== 0;
  const isOnlyOffice = offerType === FOfferType.Office;

  const commonBuildingClassTypes = new Set<EBuildingClassType>();

  if (buildingClassTypes) {
    buildingClassTypes.forEach(item => commonBuildingClassTypes.add(item));
  }

  if (withWarehouse && warehouseBuildingClassTypes) {
    warehouseBuildingClassTypes.forEach(item => commonBuildingClassTypes.add(item));
  }

  const buildingClass: EBuildingClass[] = [];

  if (buildingClassTypes) {
    if ([EBuildingClassType.A, EBuildingClassType.APlus].every(v => commonBuildingClassTypes.has(v))) {
      buildingClass.push(EBuildingClass.A);
    }

    if (
      [EBuildingClassType.B, EBuildingClassType.BPlus, EBuildingClassType.BMinus].every(v =>
        commonBuildingClassTypes.has(v),
      )
    ) {
      buildingClass.push(EBuildingClass.B);
    }

    if ([EBuildingClassType.C, EBuildingClassType.CPlus].every(v => commonBuildingClassTypes.has(v))) {
      buildingClass.push(EBuildingClass.C);
    }

    if (!isOnlyOffice && commonBuildingClassTypes.has(EBuildingClassType.D)) {
      buildingClass.push(EBuildingClass.D);
    }
  }

  return nonEmptyArrayOr(buildingClass);
}
